import {
  setStockFloor as setStockFloorPlainAction,
  setStockFloorSize as setStockFloorSizePlainAction
} from '../floor/floorSlice';
import {validStockFloorSizes} from "../floor/floorSlice";

export const setStockFloor = () => (dispatch, getState) => {
  const {plan} = getState();
  const {stockFloor} = plan;

  if (stockFloor) {
    return;
  }
  const currentSize = plan.length + 'x' + plan.width;
  const desiredSize = validStockFloorSizes.includes(currentSize) ? currentSize : validStockFloorSizes[2];

  dispatch(setStockFloorPlainAction(desiredSize));
  dispatch(setStockFloorSizePlainAction(desiredSize));
};
